import React from "react";
import MediaUpload from "./MediaUpload";

// Backwards-compatible wrapper for the original ImageUpload API.
const ImageUpload = (props) => <MediaUpload kind="image" {...props} />;
export default ImageUpload;
